import { fonts } from '@/config.fonts';
import type { IFont } from '@/typescript/interfaces/IFont';

export function loadFonts(): IFont[] {
    const fontFaces = fonts.map((font): IFont => {
        const parsedName = font.name.split('.')[0];
        const fontFace = new FontFace(parsedName, `url(${new URL(encodeURI(font.path), document.baseURI).href})`);
        document.fonts.add(fontFace);
        return { fontFace };
    });

    return fontFaces.filter((font) => font.fontFace.family);
}
